<template>
  <ErrorBoundary>
    <div ref="containerRef" class="flex justify-between items-center">
      <EventBuyBoxPrice
        :has-available-dates="true"
        :kft-event="eventData"
        :selected-time="selectedDate"
        :selected-ticket-quantity="selectedTicketQuantity"
        :type="selectedDateType"
      />
      <div v-if="isRequestButtonsVisible" class="flex gap-2 p-1">
        <client-only>
          <EventBuyBoxWatilistButton
            :display-label="!isContainerRefOverflowing"
          />
          <EventBuyBoxRequestDateButton
            v-if="showDateRequestButton"
            class="px-2 py-1"
          />
        </client-only>
      </div>
    </div>
  </ErrorBoundary>
</template>

<script lang="ts" setup>
import type {
  EventDate,
  EventDateType,
  EventDescription,
} from '~/composables/types/event'
import EventBuyBoxWatilistButton from '~/components/event/buybox/EventBuyBoxWatilistButton.vue'
import { useIsSubdomain } from '~/composables/useSubdomain'

export interface PropsEventBuyBoxHeader {
  selectedDateType: EventDateType
  selectedTicketQuantity: number
  selectedDate: EventDate
  enableSubdomain?: boolean
  isRequestButtonsVisible?: boolean
}

const props = withDefaults(defineProps<PropsEventBuyBoxHeader>(), {
  selectedDateType: 'PUBLIC',
  selectedDate: null,
  selectedTicketQuantity: 1,
  enableSubdomain: false,
  isRequestButtonsVisible: true,
})
const eventData = inject('eventData') as EventDescription
const isSubdomain = useIsSubdomain()
const showDateRequestButton = computed(() =>
  eventGetters.isDateRequestActiveBS(eventData, isSubdomain)
)
const containerRef = ref<HTMLElement | undefined>()

const { isOverflowing: isContainerRefOverflowing, checkOverflow } =
  useIsElementOverflowing(containerRef)

watch(
  () => props.selectedDate,
  async () => {
    await nextTick()
    checkOverflow()
  }
)

watch(
  () => props.selectedDateType,
  async () => {
    await nextTick()
    checkOverflow()
  }
)
</script>
